import React from 'react'
import { t } from 'ttag'
import { useModal } from 'hooks'

export const useEditCompetenciesModal = (state, handlers) => {
  const { uuid } = state
  const { handlePatchTemplate, handleRefetch, handleShowSnackbar } = handlers

  const { handleClose, handleOpen, isOpen } = useModal()

  const handleConfirm = React.useCallback(
    async (payload, { onFailureAction }) => {
      const { skills } = payload
      const { error, meta, response } = await handlePatchTemplate({
        skills,
        uuid,
      })

      if (response) {
        await handleRefetch()
        handleClose()
        handleShowSnackbar({
          message: t`Competencies were successully updated.`,
          type: 'success',
        })
      } else {
        onFailureAction?.({ message: error, type: meta?.HTTPstatus })
      }
    },
    [uuid, handleClose, handleRefetch, handlePatchTemplate, handleShowSnackbar],
  )

  return {
    handleCompetenciesClose: handleClose,
    handleCompetenciesConfirm: handleConfirm,
    handleCompetenciesOpen: handleOpen,
    isCompetenciesModalOpen: isOpen,
  }
}
